"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Container_1 = __importDefault(require("@mui/material/Container"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Chip_1 = __importDefault(require("@mui/material/Chip"));
var Grid_1 = __importDefault(require("@mui/material/Grid"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var InputAdornment_1 = __importDefault(require("@mui/material/InputAdornment"));
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var Search_1 = __importDefault(require("@mui/icons-material/Search"));
var Clear_1 = __importDefault(require("@mui/icons-material/Clear"));
var Lang_js_1 = require("../Lang.js");
var mountIsland_1 = require("../mountIsland");
var FeaturedCarousel_1 = __importDefault(require("./FeaturedCarousel"));
var BookCard_1 = __importDefault(require("./BookCard"));
var MINOR_LANGUAGES = ['fr', 'bg', 'pt'];
var BookPortal = function (_a) {
    var books = _a.books, topics = _a.topics, locale = _a.locale, title = _a.title, description = _a.description, activeTopic = _a.activeTopic, activeAuthor = _a.activeAuthor;
    var featuredTopics = (0, react_1.useMemo)(function () { return topics.filter(function (t) { return t.featured; }); }, [topics]);
    var topicSlugsInLocale = (0, react_1.useMemo)(function () {
        var slugs = new Set();
        books.filter(function (b) { return b.language === locale; }).forEach(function (b) { return b.topics.forEach(function (t) { return slugs.add(t.slug); }); });
        return slugs;
    }, [books, locale]);
    var visibleFeaturedTopics = (0, react_1.useMemo)(function () {
        if (MINOR_LANGUAGES.includes(locale)) {
            return topics.filter(function (t) { return topicSlugsInLocale.has(t.slug); });
        }
        return featuredTopics.filter(function (t) { return topicSlugsInLocale.has(t.slug); });
    }, [featuredTopics, topics, topicSlugsInLocale, locale]);
    var hasMinorBooks = (0, react_1.useMemo)(function () { return !MINOR_LANGUAGES.includes(locale) && books.some(function (b) { return MINOR_LANGUAGES.includes(b.language); }); }, [books, locale]);
    var initialTopic = (0, react_1.useMemo)(function () {
        if (activeTopic && topics.some(function (t) { return t.slug === activeTopic; }))
            return activeTopic;
        var p = new URLSearchParams(window.location.search).get('topic');
        return p && topics.some(function (t) { return t.slug === p; }) ? p : 'all';
    }, [topics, activeTopic]);
    var _b = (0, react_1.useState)(initialTopic), topic = _b[0], setTopic = _b[1];
    var _c = (0, react_1.useState)(''), search = _c[0], setSearch = _c[1];
    var featured = (0, react_1.useMemo)(function () { return books.filter(function (b) { return b.featured && b.language === locale; }); }, [books, locale]);
    var filtered = (0, react_1.useMemo)(function () {
        var term = search.trim().toLowerCase();
        return books.filter(function (b) {
            var _a;
            // On author pages books are pre-filtered server-side; skip language/topic gates
            if (!activeAuthor) {
                if (topic === 'other-languages') {
                    if (!MINOR_LANGUAGES.includes(b.language))
                        return false;
                }
                else {
                    if (b.language !== locale)
                        return false;
                    if (topic !== 'all' && !b.topics.some(function (t) { return t.slug === topic; }))
                        return false;
                }
            }
            if (term) {
                return (b.title.toLowerCase().includes(term) ||
                    ((_a = b.author) !== null && _a !== void 0 ? _a : '').toLowerCase().includes(term));
            }
            return true;
        });
    }, [books, locale, topic, search, activeAuthor]);
    // Truncate description to first sentence for the portal heading
    var shortDescription = (0, react_1.useMemo)(function () {
        if (!description)
            return '';
        var stop = description.search(/[.!?]/);
        return stop >= 0 ? description.slice(0, stop + 1) : description;
    }, [description]);
    var chipTopics = (0, react_1.useMemo)(function () { return __spreadArray(__spreadArray([
        { slug: 'all', label: (0, Lang_js_1.__)('All') }
    ], visibleFeaturedTopics.map(function (t) { var _a; return ({ slug: t.slug, label: (_a = t.label) !== null && _a !== void 0 ? _a : t.slug }); }), true), (hasMinorBooks ? [{ slug: 'other-languages', label: (0, Lang_js_1.__)('Other languages') }] : []), true); }, [visibleFeaturedTopics, hasMinorBooks]);
    return (react_1.default.createElement(Container_1.default, { maxWidth: "lg", sx: { py: 4 } },
        !activeTopic && !activeAuthor && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Typography_1.default, { variant: "h4", gutterBottom: true }, title),
            shortDescription && (react_1.default.createElement(Typography_1.default, { variant: "body1", color: "text.secondary", sx: { mb: 3, maxWidth: 680 } }, shortDescription)))),
        !activeTopic && !activeAuthor && featured.length > 0 && react_1.default.createElement(FeaturedCarousel_1.default, { books: featured, learnMore: (0, Lang_js_1.__)('Learn more') }),
        !activeTopic && !activeAuthor && (react_1.default.createElement(Box_1.default, { display: "flex", flexWrap: "wrap", gap: 1, mb: 1.5 },
            chipTopics.map(function (_a) {
                var s = _a.slug, l = _a.label;
                return (react_1.default.createElement(Chip_1.default, { key: s, label: l, onClick: function () { return setTopic(s); }, color: topic === s ? 'primary' : 'default', variant: topic === s ? 'filled' : 'outlined', clickable: true, sx: topic === s ? {} : { borderColor: 'primary.main', color: 'primary.main' } }));
            }),
            react_1.default.createElement(Chip_1.default, { component: "a", href: locale !== 'en' ? "/app/books/topics?lang=".concat(locale) : '/app/books/topics', label: "\u2026", variant: "outlined", clickable: true, sx: { borderColor: 'primary.main', color: 'primary.main' } }))),
        react_1.default.createElement(Box_1.default, { display: "flex", justifyContent: "flex-end", mb: 3 },
            react_1.default.createElement(TextField_1.default, { size: "small", placeholder: (0, Lang_js_1.__)('Search books…'), value: search, onChange: function (e) { return setSearch(e.target.value); }, sx: { width: 220 }, InputProps: {
                    startAdornment: (react_1.default.createElement(InputAdornment_1.default, { position: "start" },
                        react_1.default.createElement(Search_1.default, { fontSize: "small" }))),
                    endAdornment: (react_1.default.createElement(InputAdornment_1.default, { position: "end", sx: { visibility: search ? 'visible' : 'hidden' } },
                        react_1.default.createElement(IconButton_1.default, { size: "small", onClick: function () { return setSearch(''); }, edge: "end", "aria-label": "Clear search", sx: { p: 0.25 } },
                            react_1.default.createElement(Clear_1.default, { fontSize: "small" })))),
                } })),
        filtered.length === 0 ? (react_1.default.createElement(Box_1.default, { textAlign: "center", py: 8 },
            react_1.default.createElement(Search_1.default, { sx: { fontSize: 48, color: 'text.disabled', display: 'block', mx: 'auto', mb: 1 } }),
            react_1.default.createElement(Typography_1.default, { color: "text.secondary" }, (0, Lang_js_1.__)('No books found.')))) : (react_1.default.createElement(Grid_1.default, { container: true, spacing: 3 }, filtered.map(function (book) { return (react_1.default.createElement(Grid_1.default, { item: true, key: book.id, xs: 6, sm: 4, md: 3, lg: 2 },
            react_1.default.createElement(BookCard_1.default, { book: book }))); })))));
};
// Entry point — reads bootstrap JSON and mounts
var el = document.getElementById('msia-books-portal-container');
if (el) {
    var scriptEl = document.getElementById('msia-books-portal-bootstrap');
    var payload = (scriptEl === null || scriptEl === void 0 ? void 0 : scriptEl.textContent)
        ? JSON.parse(scriptEl.textContent)
        : { books: [], topics: [], locale: 'en', title: '', description: '' };
    (0, mountIsland_1.mountIsland)(el, react_1.default.createElement(BookPortal, { books: payload.books, topics: (_a = payload.topics) !== null && _a !== void 0 ? _a : [], locale: (_b = payload.locale) !== null && _b !== void 0 ? _b : 'en', title: (_c = payload.title) !== null && _c !== void 0 ? _c : '', description: (_d = payload.description) !== null && _d !== void 0 ? _d : '', activeTopic: payload.activeTopic, activeAuthor: payload.activeAuthor }));
}
exports.default = BookPortal;
